export const groupImuInstallationsByCanPort = installations => {
  const groupedInstallations = (installations || []).reduce((acc, installation) => {
    const canPort = parseInt(installation.can_port, 10);
    const normalizedCanPort = Number.isNaN(canPort) ? 0 : canPort;

    if (!acc[normalizedCanPort]) {
      acc[normalizedCanPort] = [];
    }
    acc[normalizedCanPort].push(installation);
    return acc;
  }, {});

  Object.keys(groupedInstallations).forEach(canPort => {
    groupedInstallations[canPort].sort((a, b) => a.imu_id - b.imu_id);
  });

  return groupedInstallations;
};

export const normalizeImuIdList = value => {
  if (!Array.isArray(value)) {
    return [];
  }
  return value.map(item => String(item).trim()).filter(Boolean);
};

export const getCanPortFromImuFieldKey = key => {
  const canImuListMatch = key.match(/^can_?(\d+)_imu_id_list$/);
  if (!canImuListMatch) {
    return null;
  }

  const canPort = parseInt(canImuListMatch[1], 10);
  return Number.isNaN(canPort) ? null : canPort;
};

export const formatCanImuIdListWithPlaceStatus = (value, expectedInstallations) => {
  const rawListText = Array.isArray(value) ? JSON.stringify(value) : String(value);
  if (!expectedInstallations || expectedInstallations.length === 0) {
    return rawListText;
  }

  const imuIdSet = new Set(normalizeImuIdList(value));
  const statusLines = expectedInstallations.map(installation => {
    const place = installation.place || `IMU ${installation.imu_id}`;
    const imuId = String(installation.imu_id);
    return {
      place,
      imuId,
      isPresent: imuIdSet.has(imuId),
    };
  });

  return {
    type: 'can_imu_status',
    rawListText,
    statusLines,
  };
};
